import React from "react";
import { Tag } from "@emisgroup/ui-tag";
import { getStatusColors } from "./Helper";
import { ExecutionStatus } from "./Types";
import "./Style.scss";

export interface StatusTagProps {
  /**
   * Display text for the tag
   */
  displayText: string;
}

/**
 * Tag to display the status of the execution
 * @param props tag props
 * @returns the tag element
 */
export const StatusTag = (props: StatusTagProps): JSX.Element => {

  const { displayText } = props;

  const { color, textColor } = getStatusColors(displayText?.toLowerCase() as ExecutionStatus);

  return (
    <Tag
      color={color}
      textColor={textColor}
      className="status-tag"
    >
      {displayText}
    </Tag>
  );
};
